import $ from "jquery/dist/jquery";

$(() => {
  $(document).on("eshop:item-list", (e, data) => {
    if (window?.NXCMS_ESHOP_GTM && window.dataLayer) {
      window.dataLayer.push({
        ecommerce: null,
      });
      window.dataLayer.push({
        event: "view_item_list",
        ecommerce: data,
      });
    }
  });

  $(document).on("eshop:item-detail", (e, data) => {
    if (window?.NXCMS_ESHOP_GTM && window.dataLayer) {
      window.dataLayer.push({
        ecommerce: null,
      });
      window.dataLayer.push({
        event: "view_item",
        ecommerce: data,
      });
    }
  });

  $(document).on("eshop:item-add", (e, gtmJSONs) => {
    if (window?.NXCMS_ESHOP_GTM && window.dataLayer) {
      window.dataLayer.push({
        ecommerce: null,
      });

      let items = [];
      $(gtmJSONs).each(function () {
        items.push({
          item_name: this.item_name,
          item_id: this.item_id,
          price: this.price,
          item_brand: this.item_brand,
          item_category: this.item_category1,
          item_category2: this.item_category2,
          item_category3: this.item_category3,
          item_category4: this.item_category4,
          quantity: this.quantity,
        });
      });

      window.dataLayer.push({
        event: "add_to_cart",
        ecommerce: {
          items: items,
        },
      });
    }
  });

  $(document).on("eshop:item-remove", (e, gtmJSONs) => {
    if (window?.NXCMS_ESHOP_GTM && window.dataLayer) {
      window.dataLayer.push({
        ecommerce: null,
      });

      let items = [];
      $(gtmJSONs).each(function () {
        items.push({
          item_name: this.item_name,
          item_id: this.item_id,
          price: this.price,
          item_brand: this.item_brand,
          item_category: this.item_category1,
          item_category2: this.item_category2,
          item_category3: this.item_category3,
          item_category4: this.item_category4,
          quantity: this.quantity,
        });
      });

      window.dataLayer.push({
        event: "remove_from_cart",
        ecommerce: {
          items: items,
        },
      });
    }
  });

  $(document).on("eshop:begin-checkout", (e, data) => {
    if (window?.NXCMS_ESHOP_GTM && window.dataLayer) {
      window.dataLayer.push({
        ecommerce: null,
      });

      window.dataLayer.push({
        event: "begin_checkout",
        ecommerce: data,
      });
    }
  });

  $(document).on("eshop:purchase", (e, data) => {
    if (window?.NXCMS_ESHOP_GTM && window.dataLayer) {
      window.dataLayer.push({
        ecommerce: null,
      });

      window.dataLayer.push({
        event: "purchase",
        ecommerce: data,
      });
    }
  });

  // really old, can be removed I think
  $(".gtagOrderSubmitForm").on("submit", () => {
    if (
      window?.NXCMS_ESHOP_GTM &&
      window?.NXCMS_ESHOP_DATALAYER_ORDER &&
      window.dataLayer
    ) {
      window.dataLayer.push({
        ecommerce: null,
      });
      let items = [];
      $(window?.NXCMS_ESHOP_DATALAYER_ORDER.items).each(function () {
        items.push({
          item_name: this.item_name,
          item_id: this.item_id,
          price: this.price,
          item_brand: this.item_brand,
          item_category: this.item_category1,
          item_category2: this.item_category2,
          item_category3: this.item_category3,
          item_category4: this.item_category4,
          quantity: this.qty,
        });
      });
      window.dataLayer.push({
        event: "purchase",
        ecommerce: {
          transaction_id: window?.NXCMS_ESHOP_DATALAYER_ORDER.transaction_id,
          value: window?.NXCMS_ESHOP_DATALAYER_ORDER.value,
          tax: window?.NXCMS_ESHOP_DATALAYER_ORDER.tax,
          shipping: window?.NXCMS_ESHOP_DATALAYER_ORDER.shipping,
          currency: window?.NXCMS_ESHOP_DATALAYER_ORDER.currency,
          items: items,
        },
      });
    }
  });

  if (window.NXCMS_EVTS_TO_FIRE) {
    $(window.NXCMS_EVTS_TO_FIRE).each(function () {
      $(document).trigger(this.evt, [this.data]);
    });
  }
});
